import { render, staticRenderFns } from "./AdminFormsList.vue?vue&type=template&id=b3cdda64&scoped=true&"
import script from "./AdminFormsList.vue?vue&type=script&lang=js&"
export * from "./AdminFormsList.vue?vue&type=script&lang=js&"
import style0 from "./AdminFormsList.vue?vue&type=style&index=0&id=b3cdda64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cdda64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3cdda64')) {
      api.createRecord('b3cdda64', component.options)
    } else {
      api.reload('b3cdda64', component.options)
    }
    module.hot.accept("./AdminFormsList.vue?vue&type=template&id=b3cdda64&scoped=true&", function () {
      api.rerender('b3cdda64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminFormsList.vue"
export default component.exports